export enum ContactModalMode {
  AddNew = 'ADD_NEW',
  AddExisting = 'ADD_EXISTING',
  AddExistingEdited = 'ADD_EXISTING_EDITED',
  EditAll = 'EDIT_ALL',
  EditConfig = 'EDIT_CONFIG',
}
